import React from 'react';
import { Check, Lock } from 'lucide-react';

const COUNTRIES = [
  'Autoristan', 'Bricologia', 'Eurocorp', 'Neo Atlas',
  'Petrolistan', 'Sudica', 'Volgovie', 'Zhongo',
];

const CountryPicker = ({ selectedCountry, onSelect, takenCountries = [], disabled }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {COUNTRIES.map((country) => {
        const isTaken = takenCountries.includes(country) && country !== selectedCountry;
        const isSelected = country === selectedCountry;

        return (
          <button
            key={country}
            onClick={() => !isTaken && !disabled && onSelect(country)}
            disabled={isTaken || disabled}
            className={`relative p-3 rounded-xl border transition-all ${
              isSelected
                ? 'border-blue-400 bg-blue-500/20 shadow-lg shadow-blue-500/20'
                : isTaken
                  ? 'border-slate-700 bg-slate-800/30 opacity-50 cursor-not-allowed'
                  : 'border-slate-600 bg-slate-800/30 hover:border-slate-500 hover:bg-slate-700/30 cursor-pointer'
            }`}
          >
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 rounded-lg bg-slate-700/50 flex items-center justify-center overflow-hidden">
                <img
                  src={require(`../../assets/flags/${country}.png`)}
                  alt={country}
                  className="w-10 h-10 object-contain"
                />
              </div>
              <span className={`text-xs font-medium truncate w-full text-center ${
                isSelected ? 'text-blue-300' : isTaken ? 'text-slate-500' : 'text-slate-300'
              }`}>
                {country}
              </span>
            </div>

            {isSelected && (
              <div className="absolute top-1 right-1 w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center">
                <Check className="w-3 h-3 text-white" />
              </div>
            )}
            {isTaken && (
              <div className="absolute top-1 right-1 w-5 h-5 bg-slate-600 rounded-full flex items-center justify-center">
                <Lock className="w-3 h-3 text-slate-400" />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default CountryPicker;
